export default Object.freeze({
  /**
   * 토큰 갱신
   */
  "/auth/refresh": {
    path: "/app/{0}/cafe24/{1}/auth/refresh",
    method: "GET",
  },
  /**
   * 멤버십 이용 현황 조회
   */
  "/get/membership/usage": {
    path: "/app/{0}/mall/{1}/api/membership/usage",
    method: "GET",
  },
  /**
   * 멤버십 매출 현황 조회
   */
  "/get/membership/sales": {
    path: "/app/{0}/mall/{1}/api/membership/sales",
    method: "GET",
  },
  /**
   * 멤버십 설정 내용 조회
   */
  "/get/membership/config": {
    path: "/app/{0}/mall/{1}/api/membership/config",
    method: "GET",
  },
  /**
   * 멤버십 설정 내용 수정
   */
  "/put/membership/config": {
    path: "/app/{0}/mall/{1}/api/membership/config",
    method: "PUT",
  },

  /**
   * 멤버십 리스트 조회
   */
  "/get/membership/list": {
    path: "/app/{0}/mall/{1}/api/membership",
    method: "GET",
  },

  /**
   * 멤버십 개별 조회
   */
  "/get/membership": {
    path: "/app/{0}/mall/{1}/api/membership/{2}",
    method: "GET",
  },
  /**
   * 멤버십 판매상태 수정
   */
  "/put/membership/status": {
    path: "/app/{0}/mall/{1}/api/membership/{2}/status",
    method: "PUT",
  },
  /**
   * 멤버십 삭제
   */
  "/del/membership": {
    path: "/app/{0}/mall/{1}/api/membership/{2}",
    method: "DELETE",
  },
  /**
   * 현재 사용중 회원 수 조회
   */
  "/get/membership/members/count": {
    path: "/app/{0}/mall/{1}/api/membership/:membership_id/members/count",
    method: "GET",
  },
  /**
   * 멤버십 등록
   */
  "/post/membership": {
    path: "/app/{0}/mall/{1}/api/membership",
    method: "POST",
  },
  /**
   * 멤버십 수정
   */
  "/put/membership": {
    path: "/app/{0}/mall/{1}/api/membership/{2}",
    method: "PUT",
  },
  /**
   * 카페24 회원등급 리스트 조회
   */
  "/get/membership/groups": {
    path: "/app/{0}/mall/{1}/api/membership/groups",
    method: "GET",
  },
  /**
   * 카페24 회원등급 상세 조회
   */
  "/get/membership/groups/detail": {
    path: "/app/{0}/mall/{1}/api/membership/groups/{2}",
    method: "GET",
  },
  /**
   * 카페24 쿠폰 리스트 조회
   */
  "/get/membership/coupons": {
    path: "/app/{0}/mall/{1}/api/membership/coupons",
    method: "GET",
  },

  /**
  * 카페24 쿠폰 조회
  */
  "/get/membership/coupon": {
    path: "/app/{0}/mall/{1}/api/membership/coupon",
    method: "GET",
  },

  /**
   * 카페24 상품분류 리스트 조회
   */
  "/get/membership/categories": {
    path: "/app/{0}/mall/{1}/api/membership/categories",
    method: "GET",
  },
  /**
   * 카페24-상품분류-상품-수-조회
   */
  "/get/membership/categories/products/count": {
    path: "/app/{0}/mall/{1}/api/membership/categories/{2}/products/count",
    method: "GET",
  },

  /**
   * 상품분류 매칭 해지
   */
  "/del/membership/categories": {
    path: "/app/{0}/mall/{1}/api/membership/{2}/categories/{3}",
    method: "DELETE",
  },
  /**
   * 멤버십 회원 목록 조회
   */
  "/get/membership/members": {
    path: "/app/{0}/mall/{1}/api/membership/members",
    method: "GET",
  },
  /**
   * 멤버십 주문 목록 조회
   */
  "/get/membership/orders": {
    path: "/app/{0}/mall/{1}/api/membership/orders",
    method: "GET",
  },
  /**
   * 멤버십 주문건 회원의 멤버십 해지
   */
  "/del/membership/orders": {
    path: "/app/{0}/mall/{1}/api/membership/orders/{2}",
    method: "DELETE",
  },
  /**
   * 멤버십 SMS 알림 설정 조회
   */
  "/get/membership/sms": {
    path: "/app/{0}/mall/{1}/api/membership/sms",
    method: "GET",
  },
  /**
   * 멤버십 SMS 알림 설정 등록/수정
   */
  "/post/membership/sms": {
    path: "/app/{0}/mall/{1}/api/membership/sms",
    method: "POST",
  },
  /**
   * 발신번호 조회
   */
  "/get/membership/sms/senders": {
    path: "/app/{0}/mall/{1}/api/membership/sms/senders",
    method: "GET",
  },
  /**
   * 결제관리 조회
   */
  "/get/membership/orders/payments": {
    path: "/app/{0}/mall/{1}/api/membership/orders/payments",
    method: "GET",
  },
  /**
   * 소진포인트 조회
   */
  "/get/membership/orders/biz-points": {
    path: "/app/{0}/mall/{1}/api/membership/orders/biz-points",
    method: "GET",
  },

  /**
   * 결제
   */
  "/post/membership/orders": {
    path: "/app/{0}/mall/{1}/api/membership/orders",
    method: "POST",
  },

  /**
   * 어드민:멤버십-쇼핑몰-노출부분-상품-페이지-설정-조회
   */
  "/get/membership/display": {
    path: "/app/{0}/mall/{1}/api/membership/{2}/display",
    method: "GET",
  },

  /**
   * 어드민:멤버십-쇼핑몰-노출부분-상품-페이지-설정-저장
   */
  "/put/membership/display": {
    path: "/app/{0}/mall/{1}/api/membership/{2}/display",
    method: "PUT",
  },

  /**
   * 어드민:멤버십-쇼핑몰-노출부분-관리-페이지-설정-조회
   */
  "/get/membership/benefits": {
    path: "/app/{0}/mall/{1}/api/membership/{2}/benefits",
    method: "GET",
  },

  /**
   * 어드민:멤버십-쇼핑몰-노출부분-관리-페이지-설정-저장
   */
  "/put/membership/benefits": {
    path: "/app/{0}/mall/{1}/api/membership/{2}/benefits",
    method: "PUT",
  },
  /**
   * 어드민:멤버십-회원-전용-상품분류-노출-수정
   */
  "/put/membership/categories/status": {
    path: "/app/{0}/mall/{1}/api/membership/categories/{2}/status",
    method: "PUT",
  },
  /**
   * 어드민:멤버십-분류별-상품-카운트-갱신
   */
  "/get/membership/categories/products/all/count": {
    path: "/app/{0}/mall/{1}/api/membership/categories/products/count",
    method: "GET",
  },
});
